/**
 * University Reviews Data
 * Expert testimonials from university researchers
 */
const assetsUrl = `${window.template_root}/src/public/`;

export const universityReviews = [
  {
    id: "1",
    quote:
      "A 12-week clinical trial followed overweight women taking a daily chlorophyll supplement versus placebo. The chlorophyll group lost significantly more body weight, saw reductions in total and LDL cholesterol, and reported fewer cravings for sweets and chocolate.",
    citation: "Citation 1. Weight Loss & Appetite Control",
    universityTitle: "Lund University, Sweden",
    logo: `${assetsUrl}img/logos/lund-university.svg`,
  },
  {
    id: "2",
    quote:
      "Studies show chlorophyllin can bind to environmental carcinogens and toxins in the gastrointestinal tract, helping to block their absorption. It also exhibits strong antioxidant activity, protecting cells from oxidative damage caused by free radicals.",
    citation: "Citation 2. Antioxidant & Detoxification Support",
    universityTitle: "Oregon State University",
    logo: `${assetsUrl}img/logos/oregon-state-university.svg`,
  },
  {
    id: "3",
    quote:
      "A systematic review and meta-analysis of 9 randomized controlled trials involving 726 patients found peppermint oil to be significantly more effective than placebo for both global improvement of digestive symptoms and reduction of abdominal pain.",
    citation: "Citation 3. Digestive Comfort & Bloating Relief",
    universityTitle: "University of Western Ontario, Canada",
    logo: `${assetsUrl}img/logos/western-ontario-university.svg`,
  },
  {
    id: "4",
    quote:
      "Researchers found that oral chlorophyllin significantly reduced intestinal and liver inflammation in mice while rebalancing the gut microbiome, specifically restoring the ratio of beneficial to harmful bacteria that is often disrupted by poor diet.",
    citation: "Citation 4. Metabolic Balance & Gut Microbiome",
    universityTitle: "Sichuan University, China",
    logo: `${assetsUrl}img/logos/sichuan-university.svg`,
  },
  {
    id: "5",
    quote:
      "This study tested chlorophyll's effect on edema – swelling caused by excess fluid in tissue, which is the underlying mechanism behind water retention and puffiness. Chlorophyll a demonstrated potent anti-inflammatory activity, reducing induced edema.",
    citation: "Citation 5. Water Retention & Puffiness",
    universityTitle: "Tropical Botanic Garden and Research Institute, India",
    logo: `${assetsUrl}img/logos/botanic-garden-institute.svg`,
  },
];

export default universityReviews;
